import { render, staticRenderFns } from "./CommonIndex.vue?vue&type=template&id=a658a1da&scoped=true&"
import script from "./CommonIndex.vue?vue&type=script&lang=js&"
export * from "./CommonIndex.vue?vue&type=script&lang=js&"
import style0 from "./CommonIndex.vue?vue&type=style&index=0&id=a658a1da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a658a1da",
  null
  
)

export default component.exports